import React from "react";
import { UserPlus } from "lucide-react";
import { motion } from "framer-motion";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

interface SignupNudgeProps {
  onDismiss: () => void;
  onBeforeNavigate?: () => void;
}

export function SignupNudge({ onDismiss, onBeforeNavigate }: SignupNudgeProps) {
  const navigate = useNavigate();

  const handleSignup = () => {
    onBeforeNavigate?.();
    navigate("/auth?tab=signup&redirect=/consultations");
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 16, scale: 0.97 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      transition={{ duration: 0.4, ease: "easeOut" }}
    >
    <Card className="p-4 border-primary/20 bg-primary/5">
      <div className="flex items-start gap-3">
        <div className="bg-primary/10 rounded-full p-2 shrink-0">
          <UserPlus className="h-5 w-5 text-primary" />
        </div>
        <div className="flex-1 space-y-2">
          <p className="text-sm font-semibold text-foreground">
            Save this conversation & get personalised results
          </p>
          <p className="text-xs text-muted-foreground">
            Create a free Grandpal account to save your chat history, shortlist nursing homes, and track your care journey — all in one place.
          </p>
          <div className="flex gap-2 pt-1">
            <Button size="sm" onClick={handleSignup} className="h-9">
              Create Free Account
            </Button>
            <Button
              size="sm"
              variant="ghost"
              onClick={onDismiss}
              className="h-9 text-muted-foreground"
            >
              Maybe later
            </Button>
          </div>
        </div>
      </div>
    </Card>
    </motion.div>
  );
}
